rdefine('app/formular/components/frm/Textbox',['backbone','app/formular/components/BaseEditForm','text!formular/frm.text.html'],function(Backbone,BaseEditForm,tPlaceholder) {
    return BaseEditForm.extend({
        bindings:{
            'select[name=subtype]':{
                value:'model.subtype'
            }
        },
        init:function() {
            this.$sel=this.$el.find(".card-body");
            this.$sel.html(Template7.compile(tPlaceholder)());
        }
    });
});